// src/themes/forest.ts
import { Theme } from "./types";

export const forestTheme: Theme = {
  "background-light": "24 33 33", // #182121
  "background-dark": "20 28 28", // Darker variant
  "card-light": "38 52 52", // #263434
  "card-dark": "34 46 46", // Darker variant
  "input-light": "51 70 70", // #334646
  "input-dark": "47 64 64", // Darker variant
  "border-light": "67 86 86", // Brighter border
  "border-dark": "63 82 82", // Darker variant
  primary: "60 179 113", // #3CB371
  "primary-hover": "46 139 87", // #2E8B57
  text: "236 243 236", // Brighter text: #ECF3EC (was #DAE3DA)
  "text-dark": "226 233 226", // #E2E9E2
  "text-secondary": "193 210 193", // Brighter secondary: #C1D2C1 (was #A1B0A1)
  "text-secondary-dark": "161 176 161", // Original kept for dark variant
};
